// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"80777251","732":"e66cbee8","977":"fa0a6a40"}[chunkId] + ".chunk.js";
};